import { next } from '@ember/runloop';

import FormCompareListItemComponent from 'webapp/components/form/compare/list-item';
import type { Args as BaseArgs } from 'webapp/components/form/range/list-base';
import FormRangeListBaseComponent from 'webapp/components/form/range/list-base';

import DsCompare from 'webapp/models-custom/ds-compare';
import type MetricLimitations from 'webapp/models-custom/metric-limitations';

export interface Args extends BaseArgs {
	initialCompare: DsCompare;
	metricLimitations: MetricLimitations;
	exceptionIds: string[];
	showOtherMetricCompare: boolean;
}

export default class FormCompareListComponent extends FormRangeListBaseComponent<Args> {
	componentClass = FormCompareListItemComponent;

	get shownCategories() {
		const exceptionIds = this.args.exceptionIds || [];

		let categories = this.args.metricLimitations.comparesByCategories.filter((item) => {
			return (
				!exceptionIds.includes(String(item.id)) ||
				String(item.id) === String(this.openCategoryId)
			);
		});

		// if `showOtherMetricCompare` false, skip showing compare with other metric unless selected
		if (
			!this.args.showOtherMetricCompare &&
			this.args.initialCompare.selectionId !== DsCompare.customOtherMetricId
		) {
			categories = categories.map((category) => {
				if (category.id === DsCompare.Category.OTHER_METRIC) {
					const copy = Object.assign({}, category);
					copy.items = category.items.filter((c) => !c.isOtherMetric);
					return copy;
				} else {
					return category;
				}
			});
		}

		return categories;
	}

	override setFirstSelected() {
		const selectedId = this.args.initialCompare.selectionId;

		if (selectedId) {
			const selectedItem = this.args.metricLimitations.compares.find(
				(item) => item.selectionId === selectedId,
			);

			if (selectedItem) {
				const dateRange = this.args.metricLimitations.dateRange!;

				next(() => {
					selectedItem.updateFromFormula(
						this.args.initialCompare.getFormula(),
						dateRange,
					);
					this.selectItem(selectedItem, true);

					this.shownCategories.some((cat) => {
						return cat.items.some((item) => {
							if (item === selectedItem) {
								this.openCategoryId = cat.id;
								return true;
							}
							return false;
						});
					});
				});
			}
		}
	}
}
